module.exports = __webpack_public_path__ + "img/_001.676a83f6.png";